import { WidgetEditorContext } from 'live/context/widget-editor'
import { DashboardContext } from 'live/context/dashboard'

import { useCallback, useContext } from 'react'

export default function useLookup(
    lookupKey = 'asset_name_event_type',
    multiple = false
): [string[], (value: string) => void] {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dashboardContext: any = useContext(DashboardContext)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const editorContext: any = useContext(WidgetEditorContext)

    const lookupValues =
        // dashboard
        dashboardContext.state?.filterValues ??
        // editor
        editorContext.filters?.applied?.lookupValues
    const lookup = lookupValues[lookupKey] ?? []

    const updateFilter = useCallback(
        value => {
            editorContext?.actions?.updateFilter('lookupValues', { [lookupKey]: value })
            editorContext?.actions?.testFilters()
        },
        [lookupKey, editorContext.actions]
    )

    return [multiple ? lookup : lookup.length > 0 ? lookup[0] : null, updateFilter]
}
